module.exports = __webpack_public_path__ + "static/media/ltcSelect.fe307a19.svg";